import { FC } from 'react';

const EmptyColumn: FC = () => null;

export default EmptyColumn;
